import React from 'react';
import { FallbackRender } from '@sentry/react';

const ErrorFallback: FallbackRender = ({ error, componentStack, resetError }) => {
  // Type guard for error
  const errorMessage = error instanceof Error ? error.toString() : String(error);
  return (
    <div
      style={{
        padding: '40px',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        textAlign: 'center',
      }}
    >
      <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>
        ⚠️ Something went wrong
      </h1>
      <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>
        The dashboard encountered an error. Our team has been notified.
      </p>
      <button
        onClick={resetError}
        style={{
          padding: '12px 24px',
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '500',
        }}
      >
        Try Again
      </button>
      {process.env.NODE_ENV === 'development' && (
        <details style={{ marginTop: '30px', textAlign: 'left' }}>
          <summary
            style={{
              cursor: 'pointer',
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
          >
            Error Details (Development Only)
          </summary>
          <pre
            style={{
              background: '#f5f5f5',
              padding: '15px',
              borderRadius: '4px',
              overflow: 'auto',
              fontSize: '12px',
            }}
          >
            {errorMessage}
            {'\n\n'}
            {componentStack}
          </pre>
        </details>
      )}
    </div>
  );
};

export default ErrorFallback;
